import { connect } from 'react-redux';
import { createSelector, createStructuredSelector } from 'reselect';
import FrameworkUtils from 'utils/framework';
import LanguageLocaleUtils from 'utils/LanguageLocale';
import PaypalRadio from 'components/RwdCheckout/Sections/Payment/Section/PaypalRadio/PaypalRadio';
import PaymentSectionEN from 'components/RwdCheckout/Sections/Payment/Section/locales/PaymentSection_en_US';
import PaymentSectionFR from 'components/RwdCheckout/Sections/Payment/Section/locales/PaymentSection_fr_CA';

const { wrapHOC } = FrameworkUtils;
const { getTextFromResource, getLocalisedDataFromResource } = LanguageLocaleUtils;

const getText = getLocalisedDataFromResource(PaymentSectionEN, PaymentSectionFR);

const textResources = createStructuredSelector({
    editPaypal: getTextFromResource(getText, 'editPaypal'),
    paypalLegalNoticePrefix: getTextFromResource(getText, 'paypalLegalNoticePrefix'),
    paypalLegalNoticeAnd: getTextFromResource(getText, 'paypalLegalNoticeAnd'),
    paypalLegalNoticeTerms: getTextFromResource(getText, 'paypalLegalNoticeTerms'),
    paypalLegalNoticePrivacy: getTextFromResource(getText, 'paypalLegalNoticePrivacy')
});

const connectedPlaceOrderButton = connect(
    createSelector(textResources, texts => {
        return texts;
    })
);

const withPlaceOrderButtonProps = wrapHOC(connectedPlaceOrderButton);

export default withPlaceOrderButtonProps(PaypalRadio);
